import { componentLabel } from '../utils/editor';
import loadComponent from './component';
import codeMergeIcon from './icons/code-merge.svg';

function loadBlock(editor, options = {}) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, codeMergeIcon),
    category: options.category,
    content: '<LearningPathway />'
  });
}

export default function (editor, opts = {}) {
  const defaults = {
    componentType: 'LearningPathway',
    componentName: 'Learning pathway',
    category: 'Learning pathway',
  };

  loadBlock(editor, { ...defaults, ...opts });
  loadComponent(editor, { ...defaults, ...opts });
}
